export const CORES_AGENDA = [
    'indigo lighten-5 black-text',
    'amber darken-1',
    'yellow accent-1 black-text',
    'green darken-4',
    'indigo',
    'light-blue',
    'teal darken-3',
    'yellow lighten-3 black-text',
    'deep-orange darken-3',
    'pink darken-4',
    'green darken-1',
    'deep-purple lighten-2 black-text',
    'lime lighten-5 black-text',
    'orange darken-4',
    'blue darken-3',
    'red darken-3',
    'light-green lighten-5 black-text',
    'brown darken-2',
    'yellow darken-4',
    'teal accent-4 black-text',
    'light-blue lighten-2 black-text',
    'purple accent-3 black-text',
    'light-blue darken-1',
    'yellow darken-3',
    'light-blue lighten-5 black-text',
    'lime accent-1 black-text',
    'purple accent-2 black-text',
    'purple lighten-1 black-text',
    'pink accent-3 black-text',
    'light-green darken-3',
    'red darken-4',
    'red lighten-2 black-text',
    'deep-purple darken-3',
    'indigo darken-2',
    'blue lighten-5 black-text',
    'amber lighten-5 black-text',
    'lime darken-4',
    'cyan darken-4',
    'deep-purple lighten-1 black-text',
    'deep-orange darken-2',
    'blue darken-1',
    'blue',
    'pink',
    'green lighten-5 black-text',
    'indigo darken-3',
    'lime accent-4 black-text',
    'red darken-1',
    'deep-orange',
    'teal accent-2 black-text',
    'orange darken-2',
    'yellow accent-2 black-text',
    'lime accent-3 black-text',
    'light-blue lighten-3 black-text',
    'red accent-2 black-text',
    'orange accent-2 black-text',
    'indigo accent-3 black-text',
    'cyan accent-3 black-text',
    'brown lighten-2 black-text',
    'cyan lighten-1 black-text',
    'orange lighten-5 black-text',
    'cyan accent-1 black-text',
    'orange lighten-4 black-text',
    'light-green darken-1',
    'pink darken-1',
    'brown lighten-5 black-text',
    'yellow lighten-5 black-text',
    'purple lighten-3 black-text',
    'light-green accent-3 black-text',
    'orange darken-3',
    'purple darken-3',
    'amber darken-3',
    'grey darken-1',
    'deep-purple darken-1',
    'yellow lighten-4 black-text',
    'brown darken-3',
    'grey darken-4',
    'cyan lighten-4 black-text',
    'indigo accent-4 black-text',
    'deep-purple lighten-3 black-text',
    'orange darken-1',
    'red lighten-3 black-text',
    'lime darken-3',
    'yellow lighten-1 black-text',
    'pink lighten-1 black-text',
    'deep-orange accent-1 black-text',
    'deep-orange lighten-1 black-text',
    'teal lighten-5 black-text',
    'orange lighten-3 black-text',
    'light-green accent-1 black-text',
    'deep-orange accent-3 black-text',
    'deep-purple accent-1 black-text',
    'light-green darken-4',
    'lime lighten-1 black-text',
    'indigo darken-4',
    'lime darken-1',
    'blue accent-2 black-text',
    'teal accent-1 black-text',
    'teal lighten-4 black-text',
    'light-green accent-4 black-text',
    'teal darken-2',
    'deep-orange lighten-4 black-text',
    'red lighten-1 black-text',
    'deep-orange darken-4',
    'yellow darken-2',
    'grey lighten-2 black-text',
    'grey lighten-3 black-text',
    'orange accent-3 black-text',
    'deep-purple lighten-4 black-text',
    'pink accent-4 black-text',
    'blue lighten-3 black-text',
    'green lighten-1 black-text',
    'blue accent-4 black-text',
    'teal accent-3 black-text',
    'green',
    'light-blue accent-3 black-text',
    'brown darken-4',
    'brown lighten-1 black-text',
    'lime darken-2',
    'purple darken-1',
    'light-green darken-2',
    'deep-purple darken-4',
    'teal',
    'indigo accent-2 black-text',
    'blue darken-4',
    'light-green lighten-1 black-text',
    'purple darken-2',
    'indigo lighten-1 black-text',
    'purple lighten-2 black-text',
    'purple darken-4',
    'red lighten-5 black-text',
    'light-blue darken-3',
    'lime lighten-4 black-text',
    'grey lighten-1 black-text',
    'green accent-1 black-text',
    'light-green lighten-3 black-text',
    'cyan lighten-2 black-text',
    'yellow darken-1',
    'light-green lighten-4 black-text',
    'cyan lighten-5 black-text',
    'amber accent-2 black-text',
    'teal lighten-1 black-text',
    'purple accent-1 black-text',
    'light-green accent-2 black-text',
    'amber',
    'brown lighten-3 black-text',
    'green lighten-3 black-text',
    'blue accent-3 black-text',
    'light-blue accent-1 black-text',
    'amber accent-3 black-text',
    'deep-orange lighten-3 black-text',
    'deep-purple',
    'cyan lighten-3 black-text',
    'deep-orange accent-2 black-text',
    'indigo accent-1 black-text',
    'grey darken-2',
    'brown darken-1',
    'teal lighten-2 black-text',
    'orange lighten-1 black-text',
    'cyan darken-3',
    'pink lighten-2 black-text',
    'teal lighten-3 black-text',
    'light-green',
    'yellow accent-3 black-text',
    'cyan darken-2',
    'light-blue accent-2 black-text',
    'grey lighten-4 black-text',
    'cyan',
    'purple accent-4 black-text',
    'green darken-3',
    'grey lighten-5 black-text',
    'pink lighten-4 black-text',
    'brown',
    'amber darken-2',
    'blue accent-1 black-text',
    'pink lighten-5 black-text',
    'deep-orange lighten-5 black-text',
    'pink accent-2 black-text',
    'pink darken-3',
    'red accent-3 black-text',
    'yellow accent-4 black-text',
    'green accent-2 black-text',
    'blue lighten-4 black-text',
    'brown lighten-4 black-text',
    'green accent-3 black-text',
    'light-green lighten-2 black-text',
    'light-blue accent-4 black-text',
    'pink darken-2',
    'green lighten-2 black-text',
    'pink lighten-3 black-text',
    'green lighten-4 black-text',
    'red lighten-4 black-text',
    'indigo lighten-4 black-text',
    'deep-purple lighten-5 black-text',
    'deep-orange accent-4 black-text',
    'light-blue darken-2',
    'indigo lighten-3 black-text',
    'light-blue darken-4',
    'lime accent-2 black-text',
    'deep-purple accent-4 black-text',
    'lime lighten-3 black-text',
    'yellow',
    'teal darken-1',
    'purple lighten-5 black-text',
    'indigo lighten-2 black-text',
    'blue darken-2',
    'lime lighten-2 black-text',
    'purple lighten-4 black-text',
    'red accent-1 black-text',
    'orange lighten-2 black-text',
    'light-blue lighten-1 black-text',
    'red darken-2',
    'deep-orange darken-1',
    'blue lighten-2 black-text',
    'lime',
    'orange',
    'yellow lighten-2 black-text',
    'cyan accent-4 black-text',
    'grey darken-3',
    'red accent-4 black-text',
    'light-blue lighten-4 black-text',
    'blue lighten-1 black-text',
    'deep-orange lighten-2 black-text',
    'amber lighten-3 black-text',
    'orange accent-1 black-text',
    'teal darken-4',
    'orange accent-4 black-text',
    'purple',
    'amber lighten-1 black-text',
    'indigo darken-1',
    'amber lighten-4 black-text',
    'pink accent-1 black-text',
    'grey',
    'deep-purple accent-3 black-text',
    'amber darken-4',
    'deep-purple darken-2',
    'red',
    'cyan darken-1',
    'green darken-2',
    'amber lighten-2 black-text',
    'cyan accent-2 black-text',
    'amber accent-4 black-text',
    'green accent-4 black-text',
    'amber accent-1 black-text',
    'deep-purple accent-2 black-text',
];


// WEBPACK FOOTER //
// ./src/constants/coresAgenda.js